<template>
    <Drawer
        :title="title"
        v-model="isBox"
        width="840"
        :mask-closable="false"
        @on-close="FormReset()"
        class-name="drawer-default"
    >
        <div class="set-scroll-form">
            <Form ref="Forms" :model="Forms" :rules="Rules" label-position="top">
                <Divider orientation="left" class="text-primary">基本信息</Divider>
                <Row :gutter="32">
                    <Col span="12">
                        <FormItem label="项目名称" prop="name">
                            <Input v-model="Forms.name" clearable placeholder="项目名称" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="项目类型" prop="type_id">
                            <Select v-model="Forms.type_id" clearable filterable placeholder="项目类型" class="width-100">
                                <Option v-for="(item,index) in typeList" :key="index" :value="item.type_id">{{item.name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="负责人" prop="head_id">
                            <Select v-model="Forms.head_id" clearable filterable placeholder="负责人" class="width-100">
                                <Option v-for="(item,index) in userList" :key="index" :value="item.admin_id">{{item.real_name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="项目状态" prop="status">
                            <Select v-model="Forms.status" clearable placeholder="项目状态" class="width-100">
                                <Option v-for="(item,index) in statusList" :key="index" :value="item.id">{{item.name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="甲方" prop="customer_id">
                            <Select v-model="Forms.customer_id" clearable filterable placeholder="选择甲方客户" class="width-100">
                                <Option v-for="(item,index) in customerList" :key="index" :value="item.id">{{item.company}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="联系电话" prop="mobile">
                            <Input v-model="Forms.mobile" clearable placeholder="联系电话" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="微信号" prop="wechat">
                            <Input v-model="Forms.wechat" clearable placeholder="微信号" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="维保周期" prop="maintain_cycle">
                            <Input v-model="Forms.maintain_cycle" clearable placeholder="如：一年两巡检" />
                        </FormItem>
                    </Col>
                </Row>
                <Divider orientation="left" class="text-primary">合同信息</Divider>
                <Row :gutter="32">
                    <Col span="12">
                        <FormItem label="项目金额" prop="money">
                            <Input v-model="Forms.money" type="number" clearable placeholder="如：10000" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="合同金额" prop="contract_money">
                            <Input v-model="Forms.contract_money" type="number" clearable placeholder="如：10000" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="签订人" prop="contract_signa_name">
                            <Input v-model="Forms.contract_signa_name" clearable placeholder="签订人" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="合同有效期" prop="contract_time">
                            <DatePicker type="daterange" format="yyyy-MM-dd" v-model="Forms.contract_time" placeholder="合同有效期" class="width-100" />
                        </FormItem>
                    </Col>
                    <Col span="24">
                        <FormItem label="合同资料" prop="contract_file">
                            <Input v-model="Forms.contract_file" disabled>
                                <template #append>
                                    <div class="f-center">
                                        <Upload
                                            :show-upload-list="false"
                                            :action="upload_url"
                                            :headers = "{'token': $store.state.token}"
                                            :format="['xls','xlsx','rar','zip','doc','docx','txt','jpg','jpeg','png','pdf']"
                                            :max-size="50 * 1024"
                                            :on-success="handleSuccess"
                                            :on-format-error="handleFormatError"
                                            :on-exceeded-size="handleMaxSize">
                                            <a href="javascript:void(0);" class="text-primary"><Icon type="md-cloud-upload" />上传</a>
                                        </Upload>
                                        <Divider type="vertical" />
                                        <a href="javascript:void(0);" @click="FileDelete()" class="text-danger"><Icon type="md-trash" />删除</a>
                                        <Divider type="vertical" />
                                        <a href="javascript:void(0);" @click="FileDownload()" class="text-violet"><Icon type="md-download" />下载</a>
                                    </div>
                                </template>
                            </Input>
                        </FormItem>
                    </Col>
                </Row>
                <Divider orientation="left" class="text-primary">其他信息</Divider>
                <Row :gutter="32">
                    <Col span="24">
                        <FormItem label="项目说明" prop="project_desc">
                            <Input v-model="Forms.project_desc" type="textarea" :rows="4" clearable placeholder="项目说明" />
                        </FormItem>
                    </Col>
                    <Col span="24">
                        <FormItem label="项目备注" prop="remark">
                            <Input v-model="Forms.remark" type="textarea" :rows="4" clearable placeholder="项目备注" />
                        </FormItem>
                    </Col>
                </Row>
            </Form>
            <div class="box-drawer-footer">
                <Button class="mr10" @click="FormReset()">取消</Button>
                <Button type="primary" :loading="$store.state.loading" @click="FormSubmit()">保存</Button>
            </div>
        </div>
    </Drawer>
</template>

<script>

import {getDispersedConfig, getDispersedDetail, saveDispersed} from "@/apis/dispersed";

export default {
    name: 'DispersedCreate',
    components: {
    },
    emits: ['trueHandler'],
    data () {
        return {
            title : '创建零星项目',
            isBox : false,
            typeList: [],
            userList: [],
            statusList: [],
            customerList: [],

            upload_url : this.$uploadFileApi,
            site_url : this.$siteApi,

            Forms : {
                small_project_id: '',
                name: '',
                type_id: '',
                head_id: '',
                status: 1,
                customer_id: '',
                mobile: '',
                wechat: '',
                money: '',
                contract_money: '',
                contract_signa_name: '',
                contract_time: [],
                contract_file: '',
                maintain_cycle: '',
                project_desc: '',
                remark: ''
            },
            Rules : {
                name: [
                    { required: true, type: 'string',  message: '请输入项目名称', trigger: 'blur' }
                ],
                type_id: [
                    { required: true, type: 'number',  message: '请选择项目类型', trigger: 'change',  transform(value) { return parseInt(value)}  }
                ],
                head_id: [
                    { required: true, type: 'number',  message: '请选择负责人', trigger: 'change',  transform(value) { return parseInt(value)}  }
                ]
            }
        }
    },
    methods: {
        /**
         功能：日期格式化
         time: 2026/09/12
         **/
        formatDate(date){
            if(!date) return '';
            if(typeof date === 'string') return date.substring(0, 10);
            const d = new Date(date);
            const month = (d.getMonth() + 1) < 10 ? '0' + (d.getMonth() + 1) : (d.getMonth() + 1);
            const day = d.getDate() < 10 ? '0' + d.getDate() : d.getDate();
            return d.getFullYear() + '-' + month + '-' + day;
        },
        /**
         功能：合同文件删除
         time: 2026/09/12
         **/
        FileDelete(){
            let that = this;
            that.Forms.contract_file = '';
        },
        /**
         功能：合同文件下载
         time: 2026/09/12
         **/
        FileDownload(){
            let that = this;
            if(that.Forms.contract_file){
                //下载文件
                const fileUrl = that.site_url + that.Forms.contract_file; // 文件的URL地址
                const parts = fileUrl.split('/');
                const fileName = parts[parts.length - 1];
                const link = document.createElement('a');
                link.href = fileUrl;
                link.target = '_blank';
                link.setAttribute('download', fileName);
                link.click();
            }else{
                that.$Message.error({ background: true,duration:3, content: '没有资料可下载'});
            }
        },
        /**
         功能：合同文件上传
         time: 2026/09/12
         **/
        handleSuccess(res){
            let that = this;
            if(res.code === 100){
                that.Forms.contract_file = res.data.url;
            }else{
                that.$Message.error({ background: true,duration:3, content: res.msg});
            }
        },
        handleFormatError(){
            let that = this;
            that.$Message.error({ background: true,duration:3, content: '只支持 jpg | png | pdf | doc | docx | xls | xlsx | rar | zip 文件' });
            return false;
        },
        handleMaxSize(){
            let that = this;
            that.$Message.error({ background: true,duration:3, content: '文件大小不能超出 50M' });
            return false;
        },

        /**
         功能：配置
         time: 2026/09/12
         **/
        GetConfig(){
            let that = this;
            getDispersedConfig().then(e=>{
                that.typeList = e.data.typeList ?? [];
                that.userList = e.data.userList ?? [];
                that.statusList = e.data.statusList ?? [];
                that.customerList = e.data.customerList ?? [];
            })
        },

        /**
         功能：详情
         time: 2026/09/12
         **/
        GetDetail(small_project_id){
            let that = this;
            that.$store.commit('SET_LOADING' , true);
            getDispersedDetail(small_project_id).then(e => {
                let data = e.data;
                for (let v of Object.keys(that.Forms)) {
                    if(v === 'type_id' || v === 'head_id' || v === 'status' || v === 'small_project_id' || v === 'customer_id') {
                        that.Forms[v] = data[v] !== '' && data[v] !== null ? parseInt(data[v]) : '';
                    }else if(v === 'contract_time'){
                        that.Forms[v] = [data.contract_start_time ?? '', data.contract_end_time ?? ''];
                    }else{
                        that.Forms[v] = data[v];
                    }
                }
            })
        },

        /**
         功能：添加
         time: 2026/09/12
         **/
        add(){
            this.isBox = true;
            this.GetConfig();
        },
        /**
         功能：编辑
         time: 2026/09/12
         **/
        edit(small_project_id){
            this.isBox = true;
            this.title = '编辑零星项目';
            this.GetConfig();
            if(small_project_id) this.GetDetail(small_project_id);
        },
        /**
         功能：提交
         time: 2026/09/12
         **/
        FormSubmit(){
            let that = this;
            this.$refs['Forms'].validate((valid) => {
                if (valid) {
                    let param = JSON.parse(JSON.stringify(that.Forms));
                    param.contract_start_time = Array.isArray(param.contract_time) && param.contract_time[0] ? that.formatDate(param.contract_time[0]) : '';
                    param.contract_end_time = Array.isArray(param.contract_time) && param.contract_time[1] ? that.formatDate(param.contract_time[1]) : '';
                    delete param.contract_time;
                    that.$store.commit('SET_LOADING' , true);
                    saveDispersed(param).then( e =>{
                        that.$Message.success({ background: true,duration:3, content: e.msg });
                        that.FormReset();
                        that.$emit('trueHandler');
                    })
                }
            })
        },
        /**
         功能：重置
         time: 2026/09/12
         **/
        FormReset(){
            this.isBox = false;
            this.title = '创建零星项目';
            this.$refs['Forms'].resetFields();
            this.Forms = {
                small_project_id: '',
                name: '',
                type_id: '',
                head_id: '',
                status: 1,
                customer_id: '',
                mobile: '',
                wechat: '',
                money: '',
                contract_money: '',
                contract_signa_name: '',
                contract_time: [],
                contract_file: '',
                maintain_cycle: '',
                project_desc: '',
                remark: ''
            };
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">
.forms {
    .ivu-form-item {
        //margin-bottom: 0 !important;
    }
}
</style>
